import PersonIcon from "@mui/icons-material/Person";
import { ErasmusServicePath, TEACHERS_INCOMING_ERASMUS } from "utils/constants";
import { tenants } from "utils/tenants";
import permissions from "app/permissions";
import ListErasmusIncomingTeachers from "./List";
import CreateErasmusIncomingTeachers from "./Create";
import EditErasmusIncomingTeachers from "./Edit";
import ShowErasmusIncomingTeachers from "./Show";

export const resources = {
  isMenu: true,
  icon: <PersonIcon />,
  tenancies: [tenants.MU],
  name: `${ErasmusServicePath}${TEACHERS_INCOMING_ERASMUS}`,
  title: "Пристигащи преподаватели",
  list: <ListErasmusIncomingTeachers />,
  create: <CreateErasmusIncomingTeachers />,
  edit: <EditErasmusIncomingTeachers />,
  show: <ShowErasmusIncomingTeachers />,
  permission: permissions.canPreviewErasmusIncomingTeachers,
  createPermission: permissions.canManageErasmusIncomingTeachers,
  editPermission: permissions.canManageErasmusIncomingTeachers,
  showPermission: permissions.canPreviewErasmusIncomingTeachers,
};
